import React      from 'react';
import classnames from 'classnames';

import { useDraggable   } from 'react-use-draggable-scroll';
import { useTranslation } from 'react-i18next';

import "./index.scss";

interface iItem {
  value: string;
  pathname: string;
}
type Props = {
  menus   : iItem[];
  onClick : (props: iItem) => void;
  selected: iItem;
};

const TopMenu: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const scrollRef: React.MutableRefObject<HTMLElement> = React.useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events } = useDraggable(scrollRef);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="top-menu-container" ref={scrollRef} {...events}>
      {props.menus.map((menu: iItem, index: number): React.ReactElement => {
        return (
          <div
            onClick={() => props.onClick(menu)}
            key={`menu-${menu.value}-${index}`}
            className={classnames("menu", { selectedMenu: props.selected === menu })}
          >
            <h4>{t(menu.value)}</h4>
          </div>
        );
      })}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default TopMenu;
